/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Brokers_AllInputs */

const cs_calendar_brokers_all = /** @type {(inputs: Calendar_Brokers_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všichni`)
};

const en_calendar_brokers_all = /** @type {(inputs: Calendar_Brokers_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone`)
};

/**
* | output |
* | --- |
* | "Everyone" |
*
* @param {Calendar_Brokers_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_brokers_all = /** @type {((inputs?: Calendar_Brokers_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Brokers_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_brokers_all(inputs)
	return cs_calendar_brokers_all(inputs)
});